import { Link } from 'react-router-dom';
import { formatter } from '../resources/funciones';
import { ContadorProducto } from './ContadorProducto';
import { useContext, useState } from 'react';
import { CarritoContext } from '../context/CarritoContext';

import {useTranslation} from 'react-i18next'


export const Card = ({ ProdCod, ProdNom, ProdPrecN, ProdPrecD, ProdImg, ProdNue, p }) => {
    
    const { aniadirProducto,aniadirPack } = useContext(CarritoContext)
    const { t, i18n } = useTranslation()
    const [contador, setContador] = useState(1)

    const handleAniadirCarrito = () =>{        
        p.ProdPack? aniadirPack(p,contador):aniadirProducto(p, contador)
    }

    return (
        <div style={{marginBottom:"3rem"}}>
            <div className="card" >
                <div className='position-relative w-100 '>
                    {
                        ProdNue&&
                        <div className="ribbon-nuevo" >
                            <span>{t("tienda_producto_msg_nuevo")}</span>
                        </div>
                    }
                </div>           
                

                <div className="d-flex justify-content-center mt-4" data-mdb-ripple-color="light">
                    <Link /* className="animate__animated animate__pulse" */
                        to={`/producto/${ProdCod}`}
                    >
                        <img src={ProdImg} alt={ProdNom} className="img-card img-tam img-fade-linear"/>
                    </Link>

                </div>
                <div className="card-body">
                    <Link className="text-reset" to={`/producto/${ProdCod}`}>
                        <h5 className="card-title mb-3">{ProdNom}</h5>
                    </Link>

                    {i18n.resolvedLanguage === "es" && <h5 className="mb-1 text-center mb-2">
                        {
                            (!ProdPrecD) ? (
                                <strong style={{ color: "#052F3E" }}>{formatter.format(ProdPrecN)}</strong>
                            ) : (
                                <>
                                    <s style={{ fontSize: "14px", color: "rgb(128,128,128)" }}>{formatter.format(ProdPrecN)}</s>
                                    <strong className="ms-2" style={{ color: "#052F3E" }}>{formatter.format(ProdPrecD)}</strong>
                                </>
                            )
                        }

                    </h5>}

                    {i18n.resolvedLanguage === "es" && <ContadorProducto idProducto={ProdCod} contador={contador} aumentarCallback={()=>setContador(contador+1)} disminuirCallback={()=>setContador(contador-1)}/>}
                    
                    {i18n.resolvedLanguage === "es" && <div className="botones-comprar my-2">
                        <button type="button" className="btn btn-primario w-100" onClick={() =>handleAniadirCarrito(p)}>{t("tienda_producto_btn_carrito")}</button>
                    </div>}
                </div>
            </div>
        </div>
    )
}
